import { Carousel, Container, Image } from "react-bootstrap";

import useWindowDimensions from "../../hooks/dementions"
import "./banner.scss";

export const HomeBanner = () => {
    const { width } = useWindowDimensions();

    const getBannerImage = () => {
        if (width >= 1200) {
            return "1920x405";
        } else if (width >= 992) {
            return "1200x253";
        } else if (width >= 768) {
            return "992x253";
        } else if (width >= 576) {
            return "768x253";
        }else{
            return "576x253";
        }
    }

    const getBannerSize = () => {

        if (width >= 1200) {
            return 1200;
        } else if (width >= 992) {
            return 992;
        } else if (width >= 768) {
            return 768;
        } else {
            return 576;
        }
    }

    return (
        <>
            <Container fluid={true} id="game-banner">
                <Carousel>
                    <Carousel.Item>
                        <div className="overlay"></div>
                        <Image src={"https://cdnphpgames.com/api/public/dl/JZd6qPc5/banner/10-03-1/" + getBannerSize() + ".jpg"} alt="" />
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className="overlay"></div>
                        <Image src={"https://cdnphpgames.com/api/public/dl/JZd6qPc5/banner/10-03-2/" + getBannerSize() + ".jpg"} alt="" />
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className="overlay"></div>
                        <Image src={"https://cdnphpgames.com/api/public/dl/JZd6qPc5/banner/10-03-3/" + getBannerSize() + ".jpg"} alt="" />
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className="overlay"></div>
                        <Image src={"https://cdnphpgames.com/api/public/dl/JZd6qPc5/banner/10-03-4/" + getBannerSize() + ".jpg"} alt="" />
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className="overlay"></div>
                        <Image src={"https://cdnphpgames.com/api/public/dl/JZd6qPc5/banner/10-03-5/" + getBannerSize() + ".jpg"} alt="" />
                    </Carousel.Item>
                </Carousel>
            </Container>
        </>
    );
}